export const Button = (props: HTMLButtonElement & { isProcessing?: boolean; children?: React.ReactNode }) => {
  const { className, isProcessing, children, ...rest } = props
  return (
    <button className={"btn " + (className ? ` ${className}` : "")} {...rest} disabled={isProcessing || props.disabled}>
      {props.isProcessing && <span className="loading loading-spinner"></span>}
      {children}
    </button>
  )
}
